
import Vue from 'vue'
import VueDraggableResizable from 'vue-draggable-resizable'

Vue.component('vue-draggable-resizable', VueDraggableResizable)
export default {
  mounted () {
    this.columns.forEach(col => {
      this.draggingMap[col.dataIndex || col.key] = col.width
    })
    this.draggingState = Vue.observable(this.draggingMap)
  },
  data () {
    return {
      draggingState: {},
      draggingMap: {}
    }
  },
  methods: {

    resizeableTitle (h, props, children) {
      let thDom = null
      const { key, ...restProps } = props
      let col
      if (key === 'selection-column') {
        // 表格加了复选框，不加这个判断col会是undefided
        col = {}
      } else {
        col = this.columns.find((col) => {
          const k = col.dataIndex || col.key
          return k === key
        })
        if (col && col.dataIndex) {
          // console.log('col-width', col.dataIndex, col.width)
        }
      }
      if (!col || !col.width) {
        return <th {...restProps}>{children}</th>
      }

      const onDrag = x => {
        this.draggingState[key] = 0
        col.width = Math.max(x, 1)
      }

      const onDragstop = () => {
        this.draggingState[key] = thDom.getBoundingClientRect().width
      }

      return (
        <th
          {...restProps}
          v-ant-ref={r => (thDom = r)}
          width={this.draggingState[key]}
          class="resize-table-th">
          {children}
          <vue-draggable-resizable
            key={col.dataIndex || col.key}
            class="table-draggable-handle"
            w={10}
            x={col.width || this.draggingState[key]}
            z={1}
            axis="x"
            draggable={true}
            resizable={false}
            onDragging={onDrag}
            onDragstop={onDragstop}></vue-draggable-resizable>
        </th>
      )
    }
  }
}
